import { Autocomplete, FormControl, Paper, TextField } from '@mui/material';

import { ReviewerInvitationProps } from '@/models/ReviewerInvitation';
import { UserType } from '@/models/User';

type ReviewerOption = {
  email: string;
  firstName?: string;
  lastName?: string;
  label?: string;
};
export function ReviewerPicker({
  reviewers,
  type,
  value,
  onChange,
}: {
  reviewers: ReviewerInvitationProps[];
  type: UserType;
  value: string; // email or "new" or ""
  onChange: (val: string) => void;
}) {
  const filtered = (reviewers ?? []).filter((r) => r.userType === type);
  const NEW_REVIEWER_OPTION: ReviewerOption = {
    email: 'new',
    label: '+ New Reviewer',
  };

  const options: ReviewerOption[] = [...filtered, NEW_REVIEWER_OPTION];
  return (
    <FormControl variant='outlined' required fullWidth>
      <Autocomplete
        options={options}
        value={options.find((o) => o.email === value) ?? null}
        getOptionLabel={(option) =>
          option.email === 'new'
            ? option.label!
            : `${option.firstName} ${option.lastName} (${option.email})`
        }
        isOptionEqualToValue={(option, val) => option.email === val.email}
        onChange={(_, newValue) => {
          onChange(newValue?.email ?? '');
        }}
        filterOptions={(opts, state) => {
          const filteredOpts = opts.filter(
            (o) =>
              o.email === 'new' ||
              `${o.firstName} ${o.lastName} ${o.email}`
                .toLowerCase()
                .includes(state.inputValue.toLowerCase())
          );

          // Ensure "+ New Reviewer" is always last
          const newOption = filteredOpts.find((o) => o.email === 'new');
          const others = filteredOpts.filter((o) => o.email !== 'new');

          return newOption ? [...others, newOption] : others;
        }}
        PaperComponent={(props) => <Paper {...props} sx={{ maxHeight: 300 }} />}
        renderInput={(params) => <TextField required {...params} label='Select a Reviewer' />}
      />
    </FormControl>
  );
}
